import { Button } from "@/components/ui/Button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/Form";
import { Input } from "@/components/ui/Input";
import { useCreateAdminCurrency } from "@/hooks/services/use-currency";
import {
  adminCurrencyFormSchema,
  adminCurrencyFormValues,
} from "@/schemas/currency";
import { useDialogStore } from "@/store/dialog-store";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { toast } from "sonner";

const CreateAdminCurrencyForm = () => {
  const createMutation = useCreateAdminCurrency();
  const { closeCreateDialog } = useDialogStore();
  const form = useForm<adminCurrencyFormValues>({
    resolver: zodResolver(adminCurrencyFormSchema),
    defaultValues: {
      currencyCode: "",
      displayName: "",
    },
  });

  const onSubmit = async (values: adminCurrencyFormValues) => {
    try {
      await createMutation.mutateAsync({
        nonce: "string",
        payload: values,
      });

      toast.success("Create currency successful!");
    } catch (error) {
      console.error("Failed to create currency:", error);
    }

    closeCreateDialog();
  };
  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
        <FormField
          control={form.control}
          name="currencyCode"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Currency Code</FormLabel>
              <FormControl>
                <Input
                  {...field}
                  placeholder="Enter currency code (e.g., USD)"
                  maxLength={6}
                  className="uppercase"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="displayName"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Display Name</FormLabel>
              <FormControl>
                <Input
                  {...field}
                  placeholder="Enter display name (e.g., US Dollar)"
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <div className="flex justify-end gap-2">
          <Button type="button" variant="outline" onClick={closeCreateDialog}>
            Cancel
          </Button>
          <Button type="submit" disabled={createMutation.isPending}>
            {createMutation.isPending ? "Creating..." : "Create Currency"}
          </Button>
        </div>
      </form>
    </Form>
  );
};

export default CreateAdminCurrencyForm;
